module.exports = "<div class=nn-base-input><input placeholder=\"{{ placeholder }}\" type=\"{{ type }}\" name=\"{{ name }}\" ng-model=ngModel></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-input/nn-base-input.directive.html
// module id = 956
// module chunks = 0